<cap-content-header>
  <cap-title>
    {{ "meldungsempfaenger.list" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <cap-functionbar-searchresult-buttons [listLoader]="listLoader">
      <button (click)="onNew()" class="btn btn-outline-primary btn-sm" type="button">
        <i class="fas fa-plus me-2"></i>{{ "functionbar.new" | translate }}
      </button>
    </cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>
<div>
  <table class="cap-table-search">
    <thead>
      <tr>
        <th>
          <cap-column-header [columnName]="'meldungsempfaenger.bezeichnung'" [sortModel]="tableSortModel.columns.get('bezeichnung')">
          </cap-column-header>
        </th>
        <th>
          <cap-column-header [columnName]="'meldungsempfaenger.sedexid'" [sortModel]="tableSortModel.columns.get('sedexId')">
          </cap-column-header>
        </th>
        <th>
          <cap-column-header
            [columnName]="'meldungsempfaenger.erhaeltmeldungen'"
            [sortModel]="tableSortModel.columns.get('erhaeltMeldungen')">
          </cap-column-header>
        </th>
        <th>
          <cap-column-header
            [columnName]="'meldungsempfaenger.erhaeltVertraulicheDaten'"
            [sortModel]="tableSortModel.columns.get('erhaeltVertraulicheDaten')">
          </cap-column-header>
        </th>
        <th>
          <!-- actions -->
        </th>
      </tr>
    </thead>
    <tbody>
      @for (item of listLoader.items; track item) {
        <tr>
          <td>
            <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_ECH0134_MELDUNGSEMPFAENGER">
              {{ item.bezeichnung }}
            </cap-link>
          </td>
          <td>
            <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_ECH0134_MELDUNGSEMPFAENGER">
              {{ item.sedexId }}
            </cap-link>
          </td>
          <td>
            {{ item.erhaeltMeldungen.toString() | translate }}
          </td>
          <td>
            {{ item.erhaeltVertraulicheDaten.toString() | translate }}
          </td>
          <td class="text-end">
            <button
              [ngbTooltip]="'functionbar.edit' | translate"
              [routerLink]="'../edit/' + item.id.id"
              class="btn btn-primary btn-sm me-2"
              placement="left"
              type="button">
              <i class="fas fa-pen"></i>
            </button>
            <span
              [ngbTooltip]="(item.hasMeldungen ? 'meldungsempfaenger.hasMeldungen' : 'functionbar.delete') | translate"
              placement="left">
              <button (click)="onDelete(item)" [disabled]="item.hasMeldungen" class="btn btn-danger btn-sm" type="button">
                <i class="fas fa-trash"></i>
              </button>
            </span>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="container">
  <div class="row justify-content-center">
    @if (listLoader.pagerData.totalPages > 1) {
      <div class="col-md-auto my-auto">
        <ngb-pagination
          (pageChange)="listLoader?.changePage($event)"
          [collectionSize]="listLoader?.pagerData.totalItems"
          [maxSize]="10"
          [page]="listLoader?.pagerData.currentPage"
          [pageSize]="listLoader?.pagerData.pageSize">
        </ngb-pagination>
      </div>
    }
    <div class="col-md-auto my-auto">{{ "total" | translate }}: {{ listLoader.pagerData.totalItems }}</div>
    <div class="col-md-auto my-auto">
      @if (listLoader) {
        <div class="container">
          @if (listLoader.state === loadingState.INFINITE_LOADING) {
            <div class="row">
              <div class="col" style="text-align: center">
                <button (click)="listLoader.suspend()" class="btn btn-white buttonGroup" container="body" type="button">
                  <i class="fas fa-spinner fa-lg fa-fw fa-spin spinner"></i>
                  {{ "component.tablewrapper.suspend" | translate }}
                </button>
              </div>
            </div>
          }
          @if (listLoader.state === loadingState.SUSPENDED) {
            <div class="row">
              <div class="col" style="text-align: center">
                <button (click)="listLoader.resume()" class="btn btn-white buttonGroup" container="body" type="button">
                  {{ "component.tablewrapper.resume" | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="row justify-content-center">
    @if (listLoader?.isSuspended) {
      <div class="col-md-auto my-auto">
        <small class="m-3">{{ "component.tablewrapper.nichtVollstaendigGeladen" | translate }}</small>
      </div>
    }
  </div>
</div>
